//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {windVane} from '../../../utils/tmallGenius'
import Hub from './hub.vue'
import iconfontLoading from '../../../items/iconfontLoading.vue'

export default {
  components: {Hub, iconfontLoading},
  data() {
    return {
      isTimeout: false, //连接超时
      isSearching: true,
      isSearchDone: false,
    }
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("添加ZigBee设备");
    next();
  },
  /*------------------------------------------- 开始运行 -------------------------------------------------------*/
  created() {

  },
  methods: {
    /*------------------------------------------- 绑定函数 -------------------------------------------------------*/
    /*  完成点击
    * */
    doneClick() {
      this.$router.go(-3);  //回首页
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/connect/zigbee/Hub_addRemote.vue